import React from "react";

const Loader = () => {
  return (
    <div className="w-screen !z-[100000] h-screen bg-white/50 dark:bg-black/50 fixed top-0 left-0">
      <div className="loader">
        <div className="orb"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
    </div>
  );
};

export default Loader;
